import { observer } from 'mobx-react-lite';
import { Typography } from '@mui/material';
import { StoreEnum } from '../../../enums/enums';
import { useStore } from '../../../hooks/store.hook';
import { themeVariables } from '../../../themeVariables';
import { theme } from '../../../themes';

const HeaderWelcomeUserComponent = observer(() => {
  const userStore = useStore(StoreEnum.UserStore);

  return (
    <>
      {userStore.masterUser && userStore.user ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            flexDirection: 'column'
          }}
        >
          <Typography
            component="div"
            style={{
              color: theme.palette.primary.main,
              fontSize: themeVariables.fontSizes.xSmall
            }}
          >
            Autentificat pe contul,
          </Typography>
          <Typography
            component="div"
            style={{
              fontWeight: themeVariables.fontWeights.semibold,
              fontSize: themeVariables.fontSizes.normal,
              color: theme.palette.primary.main
            }}
          >
            {userStore.user.firstName + ' ' + userStore.user.lastName}
          </Typography>
        </div>
      ) : (
        <>
          {userStore.user ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
                flexDirection: 'column'
              }}
            >
              <Typography
                component="span"
                style={{
                  color: theme.palette.primary.main,
                  fontSize: themeVariables.fontSizes.smaller,
                  lineHeight: 1.1
                }}
              >
                Buna,
              </Typography>
              <Typography
                component="span"
                align='right'
                style={{
                  fontWeight: themeVariables.fontWeights.semibold,
                  fontSize: themeVariables.fontSizes.normal,
                  color: theme.palette.primary.main,
                  textTransform: 'uppercase',
                  lineHeight: 1.1,
                }}
              >
                {userStore.user.firstName + ' ' + userStore.user.lastName}
              </Typography>
            </div>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
});

export default HeaderWelcomeUserComponent;
